import { ClickEventArgs, Toolbar } from "@syncfusion/ej2-angular-navigations";

import { CerFormView } from "./cer-form-view";
import { UiActionTypeEnum, UiCommand, UiCommandEvent, UiCommandSourceEnum } from "@cer/cer-ui/cer-ui-types";
import { CerToolbarCommandAdapter, CerToolbarItemState, CerToolbarStateCallback } from "@cer/cer-toolbar/cer-toolbar-command-adapter";
import { CerRandom } from "@cer/cer-util/cer-random";


export class CerFormToolbar {

  constructor(div: HTMLDivElement, view: CerFormView, buildIn: UiCommand[] = null, stateFunction: CerToolbarStateCallback = null, includeViewToolbarItems: boolean = true) {
    if (view == null || div == null) {
      return null;
    }
    if (div.id.length == 0) {
      div.id = (view.id ?? (CerRandom.AsString(10)) + "_tbc").replaceAll(' ', '_');
    }
    this.id = div.id + "_tb";

    const items: UiCommand[] = (includeViewToolbarItems ? view.toolbarCommands?.slice() : null) ?? [];
    buildIn?.forEach(c => items.push(c));

    if (items.length > 0) {
      this.createToolbar(div, this.id, view, items, stateFunction);
    }
    if (this.toolbarObj == null) {
      div.style.display = "none";
    }
  }

  private stateFunction: CerToolbarStateCallback;
  private toolbarObj: Toolbar;
  private id: string;

  public destroy() {
    if (this.toolbarObj != null) {
      //this.toolbarObj.created.unsubscribe();
      this.toolbarObj.destroy();
      this.toolbarObj = null;
    }
  }

  private createToolbar(div: HTMLDivElement, id: string, view: CerFormView, items: UiCommand[], stateFunction: CerToolbarStateCallback = null) {
    this.stateFunction = stateFunction;
    this.toolbarObj = new Toolbar({
      clicked: (e) => this.onToolbarItemClicked(view, e),
      overflowMode: 'Popup',
      cssClass: 'cer-border-bottom',
      items: CerToolbarCommandAdapter.itemsCreate(items, this.cmdIdPrefix(), stateFunction)
    });
    this.toolbarObj.created = ((e: Event) => this.onCreated(e));
    this.toolbarObj.appendTo(div);
    this.toolbarObj.element.id = id;
    //toolbarObj.triggerdataBind.addEventListener
  }

  private onCreated(e: Event) {
    this.itemStateApply();
  }

  private onToolbarItemClicked(view: CerFormView, args: ClickEventArgs): void {
    var e: UiCommandEvent = {
      source: UiCommandSourceEnum.Toolbar,
      actionType: UiActionTypeEnum.ToolbarMenuItem,
      subAction: 'none',
      commandId: this.cmdIdBase(args?.item?.id),
      args: args
    }
    view.commandNext(e);
  }

  public itemStateApply(): boolean {
    if (this.stateFunction == null || !this.isRendered()) {
      return false;
    }
    const states = this.stateFunction();

    var isChanged: boolean = false;
    for (let pair of states) {
      var [cmdId, state] = pair;
      if (this.cmdStateSet(cmdId, state)) {
        isChanged = true;
      }
    }
    if (isChanged) {
      this.resize();
    }
    return isChanged;
  }

  private resize() {
    (<any>this.toolbarObj)?.refreshPositioning();
    //(<any>this.toolbarObj)?.refreshOverflow();
  }

  private isRendered(): boolean {
    return (<any>this.toolbarObj)?.isRendered === true;
  }


  public cmdIdPrefix(): string {
    return this.id?.length > 0 ? `${this.id}_` : '';
  }

  public cmdIdPrefixAdd(cmdId: string): string {
    return this.cmdIdPrefix() + cmdId;
  }

  public cmdIdBase(cmdId: string): string {
    const prefix = this.cmdIdPrefix();
    return (prefix.length > 0) ? cmdId?.slice(prefix.length) : cmdId;
  }

  public cmdStateSet(cmdId: string, state: CerToolbarItemState): boolean {
    var isChanged: boolean = false;
    if (state.visible != null || state.disabled != null || state.iconSrc?.length != null) {
      const itemElement = this.elementGet(cmdId, true);
      if (itemElement != null) {

        if (state.visible != null) {
          if (CerFormToolbar.elementVisibleSet(itemElement, state.visible === true)) {
            isChanged = true;
          };
        }
        if (state.disabled != null) {
          if (CerFormToolbar.elementDisabledSet(itemElement, state.disabled === true)) {
            isChanged = true;
          };
        }
        if (state.iconSrc?.length > 0) {
          if (CerFormToolbar.elementIconSrcSet(itemElement, state.iconSrc)) {
            isChanged = true;
          };
        }
      }
      else {
        console.log(`Menu item '${cmdId}' not found`);
      }
    }
    return isChanged;
  }


  public elementGet(cmdId: string, itemGet: boolean): HTMLElement {
    const cmdIdUnique = this.cmdIdPrefixAdd(cmdId);
    var element = (this.toolbarObj.element?.querySelector('#' + cmdIdUnique) ??
      this.toolbarObj.element.querySelector('#' + cmdId)) as HTMLElement
    return itemGet ? element?.parentElement : element;
  }

  public static elementsGet(toolbar: Toolbar): HTMLDivElement[] {
    var toolbarElement: Element = toolbar?.element;
    if (toolbarElement == null) {
      return [];
    }
    const all = true;
    const classes = '.e-toolbar-item' + (all ? '' : ':not(.e-hidden)');
    return [].slice.call(toolbarElement.querySelectorAll(classes)) as HTMLDivElement[];
  }

  public static elementDisabledSet(itemElement: HTMLElement, enabled: boolean): boolean {
    return false;
  }

  public static elementVisibleSet(itemElement: HTMLElement, visible: boolean): boolean {
    if (itemElement != null) {
      if (visible) {
        if (itemElement.classList.contains('e-hidden')) {
          itemElement.classList.remove('e-hidden');
          return true;
        }
      }
      else {
        if (!itemElement.classList.contains('e-hidden')) {
          itemElement.classList.add('e-hidden');
          return true;
        }
      }
    }
    return false;
  }

  static elementIconSrcSet(itemElement: HTMLElement, iconSrc: string): boolean {
    const img = itemElement != null ? (itemElement?.querySelector('img') ?? CerFormToolbar.imgCreate(itemElement)) : null;
    if (!img != null) {
      if (img.src != iconSrc) {
        img.src = iconSrc;
        return true;
      }
    }
    return false;
  }

  static imgCreate(itemElement: HTMLElement): HTMLImageElement {
    const btn = itemElement?.querySelector('button');
    if (btn == null) {
      return null;
    }
    const span = btn?.querySelector('span.e-btn-icon');
    if (span != null) {
      span.classList.add('e-hidden');
    }
    const img = document.createElement('img');
    img.classList.add("e-icon-img");
    btn.appendChild(img);
    return img;
  }
}